import styled from 'styled-components';
import { Box } from '@user-portal/wikr-components';

export const SkeletonWrapper = styled(Box)`
    width: 100%;
`;
